import {$} from "../../core/cfjs/index.js";

export function $val( q,  def = '', root=d) {
    const el = $('[name="' + q + '"]', root) || $('#' + q, root)
    // A radio GROUP shares one `name` across several inputs — querySelector('[name=...]')
    // always returns the first one in DOM order, not the selected one, so a plain radio
    // field (anything not using the hidden-input "card" pattern, e.g. booking_laundry)
    // always read back its first option's value regardless of what the user picked.
    if (el?.type === 'radio') {
        return ($('[name="' + q + '"]:checked', root))?.value || def
    }
    return el?.value || def
}